import { type HTMLAttributes, type ReactNode } from 'react';

/*
    Renders one Autocomplete option, keyed by id.

    MUI keys an option by its label, and two records can share one: a course and its translation
    share a title by definition. A shared label makes React drop one of the two rows.
*/
export function renderOptionKeyedById<T extends { id: string }>(getLabel: (option: NoInfer<T>) => ReactNode) {
    return ({ key: _key, ...optionProps }: HTMLAttributes<HTMLLIElement> & { key?: unknown }, option: T) => (
        <li key={option.id} {...optionProps}>
            {getLabel(option)}
        </li>
    );
}
